import { render, staticRenderFns } from "./start-live-set.vue?vue&type=template&id=2de36050&scoped=true"
import script from "./start-live-set.vue?vue&type=script&lang=js"
export * from "./start-live-set.vue?vue&type=script&lang=js"
import style0 from "./start-live-set.vue?vue&type=style&index=0&id=2de36050&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de36050",
  null
  
)

export default component.exports